import { render, staticRenderFns } from "./vHome.vue?vue&type=template&id=8f110bd4"
import script from "./vHome.vue?vue&type=script&lang=js"
export * from "./vHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports